import { Page } from '@cast/shared-layout-ui';
import { ClustersDashboard } from '@cast/features-cluster-clusters-page';
import { useAbility } from '@cast/shared-ability-data-access';
import { useNavigate } from '@cast/infrastructure-organization';
import { useReportingTrialFleetStats } from '@cast/features-cluster-shared';
import { ReportingTrialConnectionAlert } from '@cast/shared-trial-ui';

import { useConnectClusterDialog } from '@oneclick/features/connect-cluster/useConnectClusterDialog';
import { ClustersTableRowActions } from '@oneclick/features/clusters-dashboard/_components/ClustersTableRowActions';
import { SETTINGS_PATHS } from '@oneclick/constants/navigation';
import { useReportingContactSalesDialog } from 'core/integrations';

import { TrialBannerManager } from 'components/trial/banners/TrialBannerManager';

export const HomePage = () => {
  const ability = useAbility();
  const navigate = useNavigate();
  const { openConnectClusterDialog } = useConnectClusterDialog();
  const fleet = useReportingTrialFleetStats();
  const { openReportingContactSales } = useReportingContactSalesDialog();

  return (
    <Page analytics={{ title: 'Clusters' }} testId="clusters-home-page">
      <ClustersDashboard
        onConnectCluster={() => openConnectClusterDialog()}
        isConnectClusterDisabled={!ability.can('create', 'Clusters')}
        clusterPathTemplate="/automation/external-clusters/:clusterId"
        banners={<TrialBannerManager aboutToEndBanner hasEndedBanner />}
        emptyStateBanner={
          <ReportingTrialConnectionAlert
            fleet={fleet}
            onViewPlans={() =>
              navigate(SETTINGS_PATHS.platformUsageReportingPlans)
            }
            onContactSales={() => openReportingContactSales()}
          />
        }
        renderRowActions={(cluster, { rowIndex }) => (
          <ClustersTableRowActions cluster={cluster} rowIndex={rowIndex} />
        )}
      />
    </Page>
  );
};
